<template>
  <div class="pra_all">
    <Tou></Tou>
    <div class="dad">
      <ul class="routing">
        <li>
          <span @click="Instructions_YI" class="Instructions">常见问题</span>
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-right"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
          <span class="Instructions" @click="Instructions_ER">游戏</span>
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chevron-right"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
          <span class="Instructions current">不知道云电脑中有什么游戏</span>
        </li>
      </ul>
      <div class="pra_content tong">
        <div class="title">
          <div>
            <div></div>
            云电脑中都有什么游戏?
          </div>
        </div>
        <div class="answer">
          <div class="content">
            <div class="wrapper">
              <div class="light"><i></i></div>
              <div class="main">
                <div class="col_subnav">
                  <div class="pub_subnav">
                    <ul class="subnav subnav_two">
                      <li
                        v-for="(item, index) in navBar"
                        :key="index"
                        @click="gameplatformClick(item)"
                      >
                        <a :class="{ active: item.status }">{{
                          item.platformName
                        }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="Mretrieval">
                  <span class="field">按字母检索：</span>
                  <div v-for="(item, index) in letters" :key="index">
                    <a @click="queryGameList(item)">{{ item }}</a>
                    <em v-if="item != 'Y-Z'">|</em>
                  </div>
                </div>
                <div class="game-list-content">
                  <ul>
                    <li v-for="(item, index) in platformData" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tou from '@/components/Tou.vue'
let gameList = require('../../../../static/gameList.json')
export default {
  components: {Tou},
  data () {
    return {
      navBar: [
        {
          platformVal: 'STEAM',
          platformName: 'STEAM',
          status: true
        },
        {
          platformVal: 'EPIC',
          platformName: 'EPIC',
          status: false
        },
        {
          platformVal: 'UPLAY',
          platformName: 'UPLAY',
          status: false
        },
        {
          platformVal: '其他平台',
          platformName: '其他平台',
          status: false
        }
      ],
      letters: ['A-D', 'E-H', 'I-L', 'M-P', 'Q-T', 'U-X', 'Y-Z'],
      gameList: [],
      platformData: [], // 页面展示游戏列表数据
      activePlatform: 'STEAM'
    }
  },
  mounted () {
    this.gameList = gameList.data
    this.initGameList('STEAM')
  },
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./GameProblem')
    },
    gameplatformClick (val) {
      const newNavList = this.navBar.map((item, index) => {
        item.status = false
        if (item.platformVal === val.platformVal) {
          item.status = true
        }
        return item
      })
      this.activePlatform = val.platformVal
      this.navBar = newNavList
      this.initGameList(val.platformVal)
    },
    initGameList (type) {
      const data = this.gameList.filter((item, index) => item.platformName === type)
      const platformData = Object.values(data[0].list).reduce((a, b) => {
        return a.concat(b)
      })
      this.platformData = platformData
    },
    queryGameList (type) {
      const data = this.gameList.filter((item, index) => item.platformName === this.activePlatform)
      this.platformData = data[0].list[type]
      console.log(this.activePlatform)
      console.log(type)
      console.log(this.platformData)
    }
  }
}
</script>

<style lang="scss" scoped>
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.pra_all {
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  padding-top: 170px;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  font-size: 16px;
  color: white;
  width: 100%;
  min-height: 100px !important;
  height: auto;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #3a3c48;
  .content {
    position: relative;
    margin: 0 auto;
    padding: 50px 0;
    min-height: 720px;
    width: 100%;
    // background: url("../../../assets/images/log/release-bg.png") no-repeat 100%
    //   5%;
  }
  .content .wrapper {
    position: relative;
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
  .content .light {
    position: absolute;
    left: 55px;
    top: -50px;
    width: 152px;
    height: 191px;
    background: url("../../../assets/images/log/light-top.png") no-repeat top
      center;
  }
  .content .light i {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: url("../../../assets/images/log/light.png") no-repeat top center;
  }
  .col_subnav {
    position: absolute;
    top: -5px;
    width: 100%;
    z-index: 10;
    .pub_subnav {
      position: relative;
      height: 35px;
      line-height: 35px;
      border-top: 0 none;
      .subnav {
        width: 990px !important;
        padding: 3px 0 0 6px !important;
        li {
          margin-right: 13px !important;
          position: relative;
          float: left;
          cursor: pointer;
        }
        .active {
          color: #f4c91d;
        }
      }
    }
  }
  .Mretrieval {
    position: absolute;
    top: 40px;
    width: 100%;
    z-index: 10;
    height: 33px;
    line-height: 33px;
    color: #666666;
    font-weight: bold;
    background-color: #f6fbff;
    display: flex;
    .field {
      margin: 0 10px;
    }
    div {
      a {
        color: #666666;
        font-family: Tahoma;
        cursor: pointer;
      }
      em {
        margin: 0 5px;
        color: #cccccc;
        font-weight: normal;
        font-family: Arial;
      }
    }
  }
  .game-list-content {
    padding-top: 90px;
    ul {
      display: flex;
      flex-wrap: wrap;
      width: 98%;
      margin: 0 auto;
      li {
        width: 45%;
        color: #e09241;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    padding-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 995px) and (max-width: 1199px) {
  .dad {
    margin-top: 100px;
  }
}
@media screen and (min-width: 768px) and (max-width: 994px) {
  .dad {
    margin-top: 180px;
  }
}
@media screen and (max-width: 500px) {
  .content .main .title {
    left: 30px !important;
  }
}
@media screen and (max-width: 970px) {
  .Mretrieval {
    display: none !important;
  }
  .game-list-content {
    padding-top: 40px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/GameProblems/Problem_h.vue